const palette = {
    primary: { main: '#00dc96' }, //gamma,
    secondary: { main: '#870fe6' }, //gamma otros: #ff5f00 y #ff3700
    surfaces: { 
      main: '#4A4346', // gamma, f2f6fa
      dark: '#2D2D2D', // gamma, 030609
      light: '#F5F5F5', // gamma, ffffff
      medium: '#cddee8', // gamma, cddee8
      backgroundcard: '#FF3700'
     },
    text: { white: '#ffffff', input: '#888888', dark: '#2d2d2d' },
};
const typography = {
    fontFamily: '"Nunito Sans", sans-serif',
};

const muiStyleOverrides = {
    MuiButton: {
      styleOverrides: {
        contained: {
          background: 'primary.main',
          color: 'text.dark',
          fontWeight: 600,
          minHeight: '40px',
          width: 'auto',
          fontSize: '11px',
          borderRadius: '26px',
        },
      },
    },
  };

  const customStyles = {
    InputField: {
      input: (small) => {
        const textFieldSx = { 
          fontSize: small ? '8px' : '10px',
          fontWeight: small ? 100 : 500,
        };
        return {
          width: '100%',
          "& fieldset": {
            borderRadius: '26px',
            borderColor: 'secondary.main'
          },
          width: '100%',
          textTransform: 'uppercase',
          borderColor: 'secondary.main',
          borderRadius: '26px',
          flexGrow: 1,
          input: { 
            ...textFieldSx,
            color: 'text.input', 
            backgroundColor: 'text.white', 
            textTransform: 'uppercase', 
            borderColor: 'secondary.main',
            borderRadius: '26px',
            borderWidth: '2px',
          },
          ...textFieldSx 
        };
      }
    },
    InputLabel: (small) => ({ 
      fontWeight: small ? 400 : 600,
      fontSize: small ? '8px' : '10px',
      textTransform: 'uppercase', 
      color: 'white', 
      textAlign: 'left'
    }),
    DateInput: (small) => ({
      '& input': {
        color: 'text.input', 
        backgroundColor: 'text.white', 
        textTransform: 'uppercase', 
        borderColor: 'secondary.main',
        borderWidth: '2px',
        fontSize: small ? '8px' : '10px',
        fontWeight: small ? 100 : 500,
        borderRadius: '26px',
      },
      "& fieldset": {
            borderRadius: '26px',
            borderColor: 'secondary.main'
       }
    }),
    SelectField: {
      Select: (small) => ({
        width: '100%',
        "& fieldset": {
            borderRadius: '26px',
            borderColor: 'secondary.main'
        },
        color: 'text.input', 
        backgroundColor: 'text.white', 
        textTransform: 'uppercase', 
        borderColor: 'secondary.main',
        borderWidth: '2px',
        borderRadius: '26px',
        fontSize: small ? '8px' : '10px',
        fontWeight: small ? 100 : 500,
      }),
      MenuItem: (small) => ({
        fontSize: small ? '8px' : '10px'
      }),
    },
    DocumentForm: {
      DocumentStyle: (document, selectedDocument, small) => {
        const baseStyle = {
          color: "white",
          borderRadius: '0px',
          height: '100%', width: '100%',
          fontSize: small ? 11 : 14,
          fontWeight: document === selectedDocument ? 600 : 200,
          '&:hover': {
            color: document === selectedDocument ? "primary.main" : 'surfaces.backgroundcard',
            borderColor:  document === selectedDocument ? "text.white" : "surfaces.backgroundcard",
            borderStyle: 'solid',
            borderWidth: document === selectedDocument ? '1px' : '1px',
            backgroundColor:  document === selectedDocument ? "text.white" :  "surfaces.dark",
          }
        };
        return document === selectedDocument ? {
          ...baseStyle,
          backgroundColor: "primary.main",
          color: "text.white"
        } : {
          ...baseStyle,
          color: "text.white",
          backgroundColor: "secondary.main",
          borderColor: 'surfaces.white',
          borderStyle: 'solid',
          borderWidth: '1px',
          fontWeight: 700,
        };
      },
      DocumentTypeStyle: (type, selectedType, small) => {
        const baseStyle = {
          color: "white",
          borderRadius: '0px',
          height: '100%', width: '100%',
          fontSize: small ? 12 : 14,
          p: small ? 2 : 2,
          fontWeight: type === selectedType ?  600 : 200,
          '&:hover': {
            color: type === selectedType ?  'primary.main' : "surfaces.backgroundcard",
            borderColor:  type === selectedType ? "text.white" : "surfaces.backgroundcard",
            borderStyle: 'solid',
            borderWidth: '1px',
            backgroundColor: type === selectedType ?  "text.white" : "surfaces.dark",
          }
        };
        return type === selectedType ? {
          ...baseStyle,
          backgroundColor: "primary.main",
          color: "text.white"
        } : {
          ...baseStyle,
          color: "text.white",
          backgroundColor: "secondary.main",
          borderColor: 'surfaces.white',
          borderStyle: 'solid',
          borderWidth: '1px',
          fontWeight: 700,
        };
      },
      DocumentTypeTabButtonGridItem: {},
      DateInputGridItem: { padding: 0, mt: 1, height: '100%' },
      DocumentTabButtonGridItem: {},
      PhotoInputGridItem: { height: '100%' }
    },
    PhotoInput: {
      FileBoxTopBorder: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderTopWidth: 0
      },
      FileHoverFunction: {
        transform: 'scale(0.90)'
      },
      FileBox: {
        height: '100%', 
        width: 'cal(100%-1px)',
        color: '#8a8a8a',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        willChange: 'transform',
        transition: 'transform 0.3s',
        borderWidth: '1px',
        borderColor: 'primary.main',
        borderStyle: 'solid',
        borderRadius: '20px',
        "&:hover": {
          cursor: 'pointer',
        },
      },
      FileBoxContainer: (mdUpScreen) => ({
        width: mdUpScreen ? '100%' : '100%', borderRadius: '20px',
      }),
      Image: (width, height, fromMobilePhone, verticalScreen) => {
        if (width<height) { // Si la foto es vertical
          if (fromMobilePhone) { // Si el dispositivo es telefono
            if (verticalScreen) { // Si la orientación del dispositivo es vertical
              return {
                height: '26rem',
                width: 'auto',
              };
            }else{ // Si la orientación del dispositivo es horizontal
              return {
                height: '90%',
                width: 'auto',
              };
            }
  
          }else{ // Si el dispositivo es PC de escritorio
            return {
              height: '26rem',
              width: 'auto',
            };
          }
        }else{ // Si la foto es horizontal
          if (fromMobilePhone) { // Si el dispositivo es telefono
            if (verticalScreen) { // Si la orientación del dispositivo es vertical
              if(width/height>2.4){ // Si la imagen es horizontal y larga, por sobre un ratio de 2.4=width/height
                return {
                  height: 'auto',
                  width: '90%',
                };
              }else{ // Si la imagen es horizontal y no es larga, por bajo un ratio de 2.4=width/height
                return {
                  height: 'auto',
                  width: '85%',
                };
              }
            }else{ // Si la orientación del dispositivo es horizontal
              if(width/height>2.4){ // Si la imagen es horizontal y larga, por sobre un ratio de 2.4=width/height
                return {
                  height: '80%',
                  width: 'auto',
                };
              }else{ // Si la imagen es horizontal y no es larga, por bajo un ratio de 2.4=width/height
                return {
                  height: 'auto',
                  width: '70%',
                };
              }
            }
  
          }else{ // Si el dispositivo es PC de escritorio
            return {
              height: '85%',
              width: 'auto',
            };
          }
        }
      },
      ContainerHeight: (width, height, fromMobilePhone) => (width<height ? '28rem' : (fromMobilePhone ? '16rem' : '12rem'))
    },
    Navbar: {
      Toolbar: (mdUpScreen) => ({ bgcolor: 'surfaces.dark', height: mdUpScreen ? '57px' : '50px', pl: '18px', minHeight: '50px' }),
      Logo: (mdUpScreen) => (mdUpScreen ? { cursor: 'pointer', height: '57px' } : { height: '40px', cursor: 'pointer', width: 'auto' }),
      NavItem: (isActualLocation) => {
        const activeStyle = isActualLocation ? { color: 'primary.main' } : {};
        const navItemStyle = {
            height: '100%',
            m: 'auto',
            display: 'flex',
            justifyContent: 'center',
            fontSize: '11px',
            fontWeight: 400,
            alignItems: 'center',
            cursor: 'pointer',
            color: 'text.white',
            textAlign: 'center',
            textTransform: 'uppercase',
            mx: 2,
            '&:hover': { color: 'primary.main' },
            ...activeStyle,
        };
          return navItemStyle;
      },
      LastItem: {
          hidden: false,
          container: (mdUpScreen) => ({ position: 'relative', display: 'block', margin: 0, ml: 2, width: mdUpScreen ? '200px' : '100px', height: mdUpScreen ? '57px' : '50px' }),
          background: (mdUpScreen) => ({
              position: 'absolute',
              height: mdUpScreen ? '57px' : '50px',
              width: 'auto',
            }),
          stackContainer: (mdUpScreen) => ({ height: '100%', width: '100%', position: 'absolute', top: mdUpScreen ? 2 : '15%', left: 0, textAlign: 'center', color: 'primary.main' }),
          title: (mdUpScreen) => ({ mx: 2, pt: '1px', fontSize: mdUpScreen ? '10px' : '7px', fontWeight: 200, textTransform: 'uppercase' }),
          bigText: (mdUpScreen) => ({ mx: 2, fontSize: mdUpScreen ? '13px' : '9px', fontWeight: 500, p: mdUpScreen ? 0 : 0 }),
          smallText: (mdUpScreen) => ({ mx: 2, fontSize: mdUpScreen ? '8px' : '5px', fontWeight: 200 }),
      },
  
  },
    Footer: {
      container: {
        backgroundColor: 'secondary.main',
        mx: 'auto',
        height: 'auto',
        width: '100%',
      },
      dynamicContainer: (mdUpScreen) => (mdUpScreen ? {
        mt: 5
      } : {
        mt: 2
      }),
      gridItem: { p: 2 },
      item: { color: 'text.white', p: 0, textAlign: 'left', fontSize: '12px', fontWeigth: 700 },
    },
  Camara: {
    fabStyle: {
      position: 'absolute',
      bottom: 18,
      right: 18,
    },
    closeFabStyle: {
      position: 'absolute',
      top: 18,
      right: 18,
    },
    containerTextStyle: {
      position: 'absolute',
      top: 18,
      left: 18,
      borderRadius: '0px',
      bgcolor: 'primary.main',
      p: 0,
      zIndex: 1000,
    },
    textStyle: {
      bgcolor: 'text.white',
      fontSize: '14px',
      fontWeight: 700,
      p: 2
    },
  },
  };


const staticParams = {
    homeUrl: 'https://www.gamarent.cl/es/',
    imageFromHomeUrl: false,
    carrouselBannerParams: {
      background1: { ini: 1, fin: 3, segundos: 8 },
      background2: { ini: 2, fin: 3, segundos: 15 }
    },
    transparenceOpacity: '1.0',
    bannerList: [
      'bg1.png',
      'bg2.jpg',
      'bg3.jpg',
    ],
    bannerMobileList: [
        'bg2.jpg',
    ],  
    navBarLastItemTexts: {
        title: 'TELEFONO',
        bigText: '+56 2 2938 0832',
        smallText: 'Contacto',
      },
      footerTexts: {
          column1: [
              'Av. Américo Vespucio Norte Express 1300 Pudahuel',
              'De Lunes a Viernes de 08:00 a 20:00hrs.',
              'Sábados de 08:00 a 19:00hrs.'
          ],
          column2: [
            '+56 9 5001 1598',
            '+56 2 3324 7070',
          ],
      },
      styles: { containerBorder: { borderRadius: '26px' } },
    logo: 'logoblanco.svg',
    clientName: 'Gama Rent',
    terminosYCondiciones: 'https://gamarent.contacarcloud.cl/check-in/files/Terminos%20y%20condiciones.pdf',
};

export default {
    palette,
    typography,
    muiStyleOverrides,
    customStyles,
    static: staticParams
};